import { Route, Routes } from "react-router-dom";
import Home from "./pages/homepage/Home";
import Navbar from "./components/nav/Navbar";
import Footer from "./components/nav/Footer";
import About from "./pages/about/About";
import Book from "./pages/booking/Book";
import Contact from "./pages/contact/Contact";
import Services from "./pages/services/Services";
import ServiceDetails from "./pages/services/ServiceDetails";
import PracticeAreas from "./pages/practiceAreas/PracticeAreas";
import PracticeAreasDetails from "./pages/practiceAreas/PracticeAreasDetails";
import Sectors from "./pages/sectors/Sectors";
import SectorDetails from "./pages/sectors/SectorDetails";
import Articles from "./pages/articles/Articles";
import ArticleDetails from "./pages/articles/ArticleDetails";
import ExitIntentModal from "./components/ExitIntentModal";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="workSans">
      <Navbar />
      <ExitIntentModal />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:serviceId" element={<ServiceDetails />} />
        <Route path="/areas-of-practice" element={<PracticeAreas />} />
        <Route path="/areas-of-practice/:practiceAreaId" element={<PracticeAreasDetails />} />
        <Route path="/industries" element={<Sectors />} />
        <Route path="/industries/:industryId" element={<SectorDetails />} />
        <Route path="/insights" element={<Articles />} />
        <Route path="/insights/:articleId" element={<ArticleDetails />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/book" element={<Book />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
